import * as React from "react";
import dayjs, { Dayjs } from "dayjs";
import { ChevronDownIcon } from "lucide-react";
import { Button } from "./button";
import { Label } from "./label";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { cn } from "../../lib/utils";

export interface CalendarProps {
  selected?: Dayjs;
  onSelect?: (date: Dayjs) => void;
  className?: string;
}

export const Calendar: React.FC<CalendarProps> = ({
  selected,
  onSelect,
  className,
}) => {
  return (
    <div className={cn("p-4 bg-[#23272f] text-white rounded-lg", className)}>
      <input
        type="date"
        value={selected ? selected.format("YYYY-MM-DD") : ""}
        onChange={(e) => {
          if (onSelect) onSelect(dayjs(e.target.value));
        }}
        className="border border-gray-700 bg-[#23272f] text-white rounded px-2 py-1 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
};
